// Leaf module: `utils/use-in-commerce-request/constants.ts` needs only this enum, and reaching it
// through `utils/document/constants.ts` pulled that 15 KB registry into every bundle on the chain.
// It stays in the document domain — the registry re-exports it, so the union there is unchanged.
export enum UseInCommerceRequestDocumentType {
  specimen = 'Specimen',

  filingReceiptStatementOfUse = 'Filing Receipt - Statement of Use',
  filingReceiptExtension = 'Filing Receipt - Extension',
  filingReceiptPostNoaAmendment = 'Filing Receipt - Post-NOA amendment',
  filingReceiptPetitionToReviveStatementOfUse = 'Filing Receipt - Petition to Revive + Statement of Use',
  filingReceiptPetitionToReviveExtension = 'Filing Receipt - Petition to Revive + Extension',
  filingReceiptDivide = 'Filing Receipt - Divide',
  filingReceiptDeclarationOfUse = 'Filing Receipt - Declaration of Use',
  filingReceiptRenewal = 'Filing Receipt - Renewal',

  noticeOfAllowance = 'Notice of Allowance',
  declarationOfUseNotice = 'Declaration of use notice',
  renewalNotice = 'Renewal notice',
  noticeOfAcceptanceOfStatementOfUse = 'Notice of Acceptance of Statement of Use',
  noticeOfApprovalOfExtensionRequest = 'Notice of Approval of Extension Request',
  noticeOfProcessingARequestToDivide = 'Notice of Processing a Request to Divide',
  noticeOfAbandonment = 'Notice of Abandonment',
  noticeOfRevival = 'Notice of Revival',
  noticeOfAcceptanceOfDeclarationOfUse = 'Notice of Acceptance of Declaration of Use',
  noticeOfAcceptanceOfRenewal = 'Notice of Acceptance of Renewal',

  foreignCertificate = 'Foreign certificate',
  commentAttachment = 'Comment attachment',
  filingData = 'Filing data',
  other = 'Other',
}
